import { Model } from '@vuex-orm/core';
import moment from 'moment';
import { find } from 'lodash-es';
import { weekday } from '../datetime';

const WINDOW_MINUTES = 30;

/**
 * ORM Model
 * @see {@link https://vuex-orm.github.io/vuex-orm/guide/components/models.html}
 */
export class Period extends Model {
  static entity = 'periods'

  static primaryKey = 'id'

  static fields () {
    return {
      id: this.attr(null),
      label: this.string(null),
      description: this.string(null),
      day: this.attr(null),
      time_start: this.attr(null),
      time_end: this.attr(null),
      server_time: this.attr(null),
    };
  }

  static beforeCreate(model) {
    model.server_time_offset = moment(model.server_time).diff(moment());
  }

  get start_time () {
      return moment().isoWeekday(this.day).hour(0).minutes(this.time_start).seconds(0);
  }

  get start_time_formatted () {
    return this.start_time.format('H:mm');
  }

  get end_time () {
      return moment().isoWeekday(this.day).hour(0).minutes(this.time_end).seconds(0);
  }

  get end_time_formatted () {
    return this.end_time.format('H:mm');
  }

  get serverTime () {
    return moment().add(this.server_time_offset);
  }

  get timeslot () {
    return `${this.start_time_formatted} - ${this.end_time_formatted}`;
  }

  get secondsToEnd () {
    return this.end_time.diff(this.serverTime, 'seconds');
  }

  get secondsToStart () {
    return this.start_time.diff(this.serverTime, 'seconds');
  }

  get isActive () {
    return this.day === weekday() &&
        this.serverTime.isBetween(this.start_time, this.end_time, 'minute', '[]');
  }

  get isInWindow() {
    return this.day === weekday() &&
        this.serverTime.isBetween(this.start_time.subtract(WINDOW_MINUTES, 'minutes'), this.end_time.add(WINDOW_MINUTES, 'minutes'), 'minute', '[]');
  }

  start () {
    return Period.update({
      where: this.id,
      data: {
        minutes_to_start: 0
      }
    });
  }

  end () {
    return Period.update({
      where: this.id,
      data: {
        minutes_to_end: 0
      }
    });
  }

  get isExpired () {
    return this.day === weekday() &&
        this.secondsToEnd <= 0
  }

  static async getCurrent () {
    let periods = Period.all();
    if (periods.length === 0) {
      await Period.$fetch();
    }
    return find(Period.all(), (period) => {
      return period.isActive;
    });
  }

  static async currentWithWindow () {
    let periods = Period.all();
    if (periods.length === 0) {
      await Period.$fetch();
    }
    return find(Period.all(), (period) => {
      return period.isInWindow;
    });
  }

  /**
   * Axios default overrides
   * @see {@link https://github.com/vuex-orm/plugin-axios/blob/master/README.md}
   */
  static methodConf = {
    http: {
      url: 'regicall/periods'
    },
    methods: {
    }
  }
}
